module.exports = __webpack_public_path__ + "static/50-54cccaf8939c68ecbf0ebdb2ebef545b.png";